import { PlanGroup } from '@superfunnel/types';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../Firebase';

interface CreateCheckoutResponse {
  checkoutUrl: string;
}

type PlansResponse = PlanGroup[];

interface CreateCustomPlanRequest {
  accountId: string;
  planType: 'custom';
  planName: string;
  billingInterval: 'month' | 'year';
  price: number;
  currency?: string;
  customLimits?: {
    domains?: number | null;
    pages?: number | null;
    publishedPages?: number | null;
    members?: number | null;
    aiCredits?: number | null;
    buffer?: number;
  };
  startDate?: string;
  endDate?: string;
  contractId?: string;
  notes?: string;
}

interface CreateCustomPlanResponse {
  success: boolean;
  subscriptionId: string;
  message: string;
}

export async function createCheckoutSession(
  accountId: string,
  variantId: string,
  redirectUrl?: string,
  discountCode?: string,
): Promise<CreateCheckoutResponse> {
  const fn = httpsCallable<
    {
      accountId: string;
      variantId: string;
      redirectUrl?: string;
      discountCode?: string;
    },
    CreateCheckoutResponse
  >(functions, 'subscriptions/createCheckout');

  const result = await fn({ accountId, variantId, redirectUrl, discountCode });
  return result.data;
}

export async function createAdminCheckoutSession(
  accountId: string,
  variantId: string,
  redirectUrl?: string,
  discountCode?: string,
): Promise<CreateCheckoutResponse> {
  const fn = httpsCallable<
    {
      accountId: string;
      variantId: string;
      redirectUrl?: string;
      discountCode?: string;
    },
    CreateCheckoutResponse
  >(functions, 'subscriptions/createAdminCheckout');

  const result = await fn({ accountId, variantId, redirectUrl, discountCode });
  return result.data;
}

export async function cancelSubscription(accountId: string): Promise<void> {
  const fn = httpsCallable<{ accountId: string }, void>(
    functions,
    'subscriptions/cancelSubscription',
  );

  await fn({ accountId });
}

export async function getAvailablePlans(): Promise<PlansResponse> {
  const fn = httpsCallable<Record<string, never>, PlansResponse>(
    functions,
    'subscriptions/getPlans',
  );

  const result = await fn({});
  return result.data;
}

export async function createCustomPlan(
  data: CreateCustomPlanRequest,
): Promise<CreateCustomPlanResponse> {
  const fn = httpsCallable<CreateCustomPlanRequest, CreateCustomPlanResponse>(
    functions,
    'subscriptions/createCustomPlan',
  );

  const result = await fn(data);
  return result.data;
}
